import React from 'react';
import PropTypes from 'prop-types';
import './styles.scss';

const Button = ({
  onHandleClick, Disabled, buttonStyle, Caption
}) => (
  <button
    onClick={onHandleClick}
    className={buttonStyle}
    disabled={Disabled}
  >{Caption}
  </button>
);

Button.defaultProps = {
  onHandleClick: () => {},
  Disabled: false,
  Caption: 'Button'
};

Button.propTypes = {
  onHandleClick: PropTypes.func,
  buttonStyle: PropTypes.string.isRequired,
  Disabled: PropTypes.bool,
  Caption: PropTypes.string
};

export default Button;



// WEBPACK FOOTER //
// ./src/pages/LoginAdmin/commponents/Button/index.js